export default __webpack_public_path__ + "static/media/profile.56b55af6.svg";